import { React, Component, Container, _ } from 'utils';
import { Campaigns } from 'model';
import Campaign from './campaign';

class CampaignList extends Component {

	static getStores() {
		return [Campaigns];
	}

	static calculateState() {
		var { campaigns } = Campaigns.getState();

		return {
			campaigns
		};
	}

	render() {
		var { campaigns } = this.state;

		var vCampaigns = '';

		if(campaigns && campaigns.length > 0) {
			vCampaigns = campaigns.map(function(item, index) {
				return <Campaign key={index} model={item} />
			});
		} else {
			vCampaigns = <div className="panel-body">
				{ _('no_maps_message', 'Kreirajte mape i spremajte profile kako bi si olakšali snalaženje među spremljenim profilima.') }
			</div>
		}

		return <div className="items-box">
			{ vCampaigns }
		</div>
	}
}

const campaignList = Container.create(CampaignList);
export default campaignList;


// WEBPACK FOOTER //
// ./src/modules/campaign/campaignList.js